let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("29Pi2")).then(() => parcelRequire('2EfPo'));